
import { BzDate } from "js/helper";
let mixin = {
  filters: {
    priceFormat(price) {
      return parseFloat(price).toFixed(2);
    },
    dateFormat(SystemDate) {
      if (SystemDate === null) return "";
      return BzDate.format(new Date(SystemDate), "yyyy-MM-dd");
    },
    TimeFormat(SystemDate) {
      if (SystemDate === null) return "";
      return BzDate.format(new Date(SystemDate), "hh:mm:ss");
    }

  },
  data() {
    return {

    }
  },
  methods: {


  }
};

export default mixin;



// WEBPACK FOOTER //
// ./src/modules/js/mixin.js